import * as Yup from 'yup'

const allowedExtensions: { [key: string]: string[] } = {
    pdf: ['.pdf'],
    img: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff'],
    ppt: ['.ppt', '.pptx', '.pot', '.potx', '.pps', '.ppsx', '.key'],
    audio: ['.mp3', '.wav', '.ogg', 'flac', '.aac', '.wma', '.m4a'],
    video: [
        '.mp4',
        '.avi',
        '.mkv',
        '.mov',
        '.wmv',
        '.flv',
        '.mpg',
        '.mpeg',
        '.3gp',
        '.webm',
    ],
    document: ['.doc', '.docx', '.txt', '.rtf'],
}

const uploadtaskSchema = Yup.object().shape({
    title: Yup.string().required('Required'),
    type: Yup.string().required('Required'),
    link: Yup.string()
        .test('is-url-valid', (value: string | undefined, context) => {
            if (!['Link', 'link'].includes(context.parent.type)) {
                return true // Skip validation, consider it valid
            }

            // Check if the field is empty and of type 'Link'
            if (value === null || value === undefined || value?.trim() === '') {
                return context.createError({
                    message: 'Link should be provided',
                })
            }

            const urlRegex =
                /^(https?:\/\/)?([a-zA-Z0-9.-]+(:[a-zA-Z0-9.-]+)?@)?(www\.)?([a-zA-Z0-9.-]+)(\.[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?$/

            // Check if link matches the regex and is not empty
            if (urlRegex.test(value as string) && value?.trim() !== '') {
                return true // Link is valid
            } else {
                return context.createError({
                    message: `Please enter a valid link`,
                })
            }
        })
        .nullable(),
    description: Yup.string().required('Required'),
    isEditing: Yup.boolean(),
    filetype: Yup.string().when('isEditing', (isEditing, schema) => {
        return isEditing[0]
            ? schema
            : schema
                  //   .required('File should be provided')
                  .test({
                      name: 'type',
                      message: 'File should be provided',
                      test: function (value, context) {
                          const resourcetype = context.parent.type
                          if (resourcetype?.toLowerCase() !== 'link') {
                              return value !== undefined && value !== ''
                          } else {
                              return true
                          }
                      },
                  })
                  .test('fileFormat', function (value, context) {
                      const resourcetype = context.parent.type as string
                      if (!value) {
                          return true // No error if value is empty
                      }
                      const extensions =
                          allowedExtensions[resourcetype?.toLowerCase()] || []
                      if (
                          extensions &&
                          !extensions.some((ext) =>
                              ext
                                  .toLowerCase()
                                  .endsWith(value.split('.').pop() || '')
                          )
                      ) {
                          return this.createError({
                              message: `Supported file types for ${resourcetype}: (${extensions.join(', ')})`,
                          })
                      }

                      return true
                  })
    }),
})

export { uploadtaskSchema }
